import React, { useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import { Calendar, Clock, HardHat } from '@phosphor-icons/react';
import { useNavigate } from 'react-router-dom';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const fmtH = (n) => `${(Math.round((Number(n) || 0) * 10) / 10).toLocaleString('fr-FR')}h`;
const fmtD = (n) => `${(Math.round((Number(n) || 0) * 10) / 10).toLocaleString('fr-FR')}j`;

export const ProjectLaborConsumptionWidget = () => {
  const [data, setData] = useState(null);
  const navigate = useNavigate();

  const fetch = useCallback(async () => {
    try {
      const res = await axios.get(`${API_URL}/api/projects/labor-summary`, { withCredentials: true });
      setData(res.data);
    } catch { /* ignore */ }
  }, []);

  useEffect(() => { fetch(); }, [fetch]);

  if (!data) return null;
  const { rows, totals, hourly_rate } = data;
  const visibleRows = rows.filter(r => r.hours > 0 || r.hours_pending > 0);
  const fmtEUR = (n) => `${(Math.round((Number(n) || 0))).toLocaleString('fr-FR')} EUR`;

  return (
    <div className="card" data-testid="project-labor-consumption-widget" style={{ padding: 0, overflow: 'hidden' }}>
      <div style={{ padding: '14px 18px', borderBottom: '1px solid #E2E2E6', background: 'linear-gradient(135deg, #047857 0%, #065F46 100%)', color: 'white' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 12 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <HardHat size={24} weight="bold" />
            <h3 style={{ margin: 0, fontSize: '1rem' }}>Consommation MO par chantier</h3>
          </div>
          <div style={{ display: 'flex', gap: 22, fontSize: '0.85rem', flexWrap: 'wrap' }}>
            <div><span style={{ opacity: 0.8 }}>Chantiers :</span> <b>{totals.project_count}</b></div>
            <div><Clock size={14} style={{ verticalAlign: 'middle' }} /> <b>{fmtH(totals.hours)}</b></div>
            <div><Calendar size={14} style={{ verticalAlign: 'middle' }} /> <b>{fmtD(totals.days)}</b></div>
            <div><span style={{ opacity: 0.8 }}>Cout MO :</span> <b>{fmtEUR(totals.cost)}</b></div>
          </div>
        </div>
        <div style={{ marginTop: 6, fontSize: '0.78rem', opacity: 0.9 }}>
          Sur la base de {data.day_hours}h / jour - taux {hourly_rate} EUR/h. Les heures en attente sont indiquees separement.
        </div>
      </div>

      {visibleRows.length === 0 ? (
        <div style={{ padding: 20, textAlign: 'center', color: '#9E9E9E', fontSize: '0.85rem' }}>
          Aucune main-d'oeuvre pointee pour le moment.
        </div>
      ) : (
        <div style={{ overflow: 'auto' }}>
          <table className="data-table" style={{ fontSize: '0.85rem', margin: 0 }}>
            <thead>
              <tr>
                <th>Chantier</th>
                <th style={{ textAlign: 'right' }}>Heures</th>
                <th style={{ textAlign: 'right' }}>Jours</th>
                <th style={{ textAlign: 'right' }}>Cout MO</th>
                <th style={{ textAlign: 'right' }}>En attente</th>
              </tr>
            </thead>
            <tbody>
              {visibleRows.map(r => (
                <tr
                  key={r.id}
                  data-testid={`labor-row-${r.id}`}
                  style={{ cursor: 'pointer' }}
                  onClick={() => navigate(`/projects?id=${r.id}`)}
                  title="Ouvrir la fiche chantier"
                >
                  <td style={{ fontWeight: 600 }}>
                    {r.name}
                    {r.client_name ? <div style={{ fontSize: '0.72rem', color: '#9E9E9E', fontWeight: 400 }}>{r.client_name}</div> : null}
                  </td>
                  <td style={{ textAlign: 'right' }}>{fmtH(r.hours)}</td>
                  <td style={{ textAlign: 'right', fontWeight: 700, color: '#047857' }}>{fmtD(r.days)}</td>
                  <td style={{ textAlign: 'right', fontWeight: 700, color: '#1D4ED8' }}>{fmtEUR(r.cost)}</td>
                  <td style={{ textAlign: 'right', color: r.hours_pending > 0 ? '#D97706' : '#C5C7CD' }}>
                    {r.hours_pending > 0 ? `${fmtH(r.hours_pending)} - ${fmtEUR(r.cost_pending)}` : '-'}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default ProjectLaborConsumptionWidget;
